import React from "react";
import '../../css/sorting/sorter.less';
import classnames from 'classnames';
import { direction } from '../constants';

/**
 * @param {String} direction One of contants/direction
 * @description Creates a sorting icon showing the active direction if set
 */
const Sorter = ({ direction: dir = direction.NONE }) => {

    const classes = classnames({
        'sorter': true,
        'sorted-asc': dir === direction.ASC,
        'sorted-desc': dir === direction.DESC,
    });

    return <span className={classes}></span>;
};

export default Sorter;